import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Datepicker = _resolveComponent("Datepicker");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_Datepicker, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                "enable-seconds": "",
                format: "dd MMM yyyy HH:mm:ss",
                placeholder: _ctx.placeholder || 'Choose a date',
                disabled: _ctx.disabled,
                "enable-time-picker": _ctx.enableTimePicker,
                "min-date": _ctx.minDate,
                "month-change-on-scroll": false,
                "hide-offset-dates": true,
                markers: _ctx.markers,
                onUpdateMonthYear: _ctx.updateMonthYear
            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "enable-time-picker", "min-date", "markers", "onUpdateMonthYear"])
        ]),
        _: 1 /* STABLE */
    }));
}
